<div class="auth">
  <div class="auth-glow" aria-hidden="true"></div>

  <div class="auth-card">
    <span class="brand"><img class="brand-logo-img" src="iflyfinance-logo.png" alt="iFlyFinance" /></span>

    <p class="eyebrow">Producer console</p>
    <h1 class="hero-title">Sign in</h1>
    <p class="hero-sub">Access your account to manage quotes and premium financing.</p>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="auth-form">
      <mat-form-field appearance="outline" class="ifq-field">
        <mat-label>Email</mat-label>
        <input
          matInput
          type="email"
          formControlName="email"
          placeholder="Enter your email"
          autocomplete="email"
          required>
        <mat-icon matSuffix>email</mat-icon>
        <mat-error *ngIf="loginForm.get('email')?.hasError('required')">
          Email is required
        </mat-error>
        <mat-error *ngIf="loginForm.get('email')?.hasError('email')">
          Please enter a valid email address
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="ifq-field">
        <mat-label>Password</mat-label>
        <input
          matInput
          [type]="hidePassword ? 'password' : 'text'"
          formControlName="password"
          placeholder="Enter your password"
          autocomplete="current-password"
          required>
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="hidePassword = !hidePassword"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hidePassword">
          <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-error *ngIf="loginForm.get('password')?.hasError('required')">
          Password is required
        </mat-error>
        <mat-error *ngIf="loginForm.get('password')?.hasError('minlength')">
          Password must be at least 8 characters
        </mat-error>
      </mat-form-field>

      <button
        type="submit"
        class="cta cta--block"
        [disabled]="loginForm.invalid || isLoading">
        <mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner>
        <span *ngIf="!isLoading">Sign In</span>
      </button>

      <div class="auth-links">
        <a class="text-link" routerLink="/forgot-password">Forgot your password?</a>
      </div>
    </form>

    <p class="legal">Protected access &middot; iFlyFinance, Inc.</p>
  </div>
</div>
